'use strict';

$(document).ready(function () {
    $(document).on('click', '.url-copy-btn', function () {
        var shareUrl = window.location.href;
        navigator.clipboard.writeText(shareUrl);
        $(this).blur();
    });
});

